import React from 'react'

export default function RoundedRightArrowSVG({onClick, disabled}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="none" viewBox="0 0 72 72" onClick={onClick} className={disabled ? 'rounded-arrow__disabled right-arrow__svg' : 'right-arrow__svg'}>
      <path stroke="#FBFBFD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M32 44l8-8-8-8" />
    </svg>
  )
}
